import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'

import Home from '@/components/Home'
import About from '@/components/About'
import Books from '@/components/Books'
import Participate from '@/components/Participate'
import Resources from '@/components/Resources'
import Post from '@/components/Post'
import Preview from '@/components/Preview'
import Episodes from '@/components/Episodes'
import Extras from '@/components/Extras'
import Search from '@/components/Search'
import Tag from '@/components/Tag'
import NotFound from '@/components/NotFound'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/books',
    name: 'Books',
    component: Books
  },
  {
    path: '/participate',
    name: 'Participate',
    component: Participate
  },
  {
    path: '/resources',
    name: 'Resources',
    component: Resources
  },
  {
    name: 'Episodes',
    path: '/episodes',
    component: Episodes
  },
  {
    name: 'Extras',
    path: '/extras',
    component: Extras
  },
  {
    name: 'Search',
    path: '/search',
    component: Search
  },
  {
    name: 'Preview',
    path: '/preview',
    component: Preview
  },
  {
    name: 'Post',
    path: '/:slug',
    component: Post
  },
  {
    name: 'Category',
    path: '/category/:topic',
    component: Episodes
  },
  {
    name: 'Tag',
    path: '/tag/:tag',
    component: Tag
  },
  {
    name: 'NotFound',
    path: '/404',
    component: NotFound,
    alias: '*'
  }
]

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  } else if (to.hash) {
    return {
      selector: to.hash
    }
  } else {
    return { x: 0, y: 0 }
  }
}

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior
})

Vue.use(VueAnalytics, {
  id: 'UA-21941912-1',
  router
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js